import Vue from 'vue'
import SaleObject from "./../../../services/sale/SaleObject"
import saleValidator from "./../../../services/sale/saleValidator"

var saleForm = {
  id: null,
  company: null,
  customer: null,
  salesman: null,
  operation: null,
  has_negotiation: 0,
  delivery_type: null,
  negotiation_value: null,
  negotiation_comments: null,
  sale_products: [],
  general_discount: 0,
  general_discount_percent: 0,
  discount: 0,
  discount_percent: 0,
  sale_payment_terms: [],
  sale_bills: [],
  notes: null,
  status: null,
}

export default {

  namespaced: true,

  state: () => ({

    saleProductEditIndex: null,

    baseSaleForm: saleForm,

    saleForm: saleForm,

  }),

  getters: {

    isInsert: (state) => {
      return state.saleForm.id == null
    },

    sale: (state) => {
      let saleObject = new SaleObject()

      saleObject.setSale(state.saleForm)

      return saleObject.getSaleForm()
    },

    hasProducts: (state) => {
      return state.saleForm.sale_products.length > 0
    },

    maxDiscountAllowed: (state, getters) => {
      return Math.min(...state.saleForm.sale_payment_terms.filter(row => (row.payment_term)).map(row => parseFloat(row.payment_term.max_discount_percent)))
    },

    errorMessages: (state, getters) => {
      return saleValidator(state.saleForm)
    },

    hasErrors: (state, getters) => {
      return getters.errorMessages.length > 0
    }

  },


  mutations: {

    reset(state) {
      state.saleForm = JSON.parse(JSON.stringify(state.baseSaleForm));
    },

    setSale(state, sale) {
      state.saleForm = JSON.parse(JSON.stringify(sale))
    },

    setSaleCopy(state, sale) {
      sale.id = null
      sale.status = null
      sale.number = null
      sale.operation = { id: 1 }

      // Limpar datas
      sale.saved_at = null
      sale.drafted_at = null
      sale.proposed_at = null
      sale.proposal_expires_at = null
      sale.ordered_at = null
      sale.sold_at = null
      sale.canceled_at = null
      sale.approved_at = null
      sale.approved_by = null

      // Limpar status de entrega e referências
      sale.delivery_status = null
      sale.stock_status = 0
      sale.finance_status = 0
      sale.returning_from_sale_id = null

      // Limpar transações antigas
      sale.account_transaction = null

      if (sale.sale_products) {
        sale.sale_products.forEach((product) => {
          delete product.id
          delete product.sale_id

          product.stock_status = 0
          product.withdraw_quantity = 0
        })
      }

      if (sale.sale_payment_terms) {
        sale.sale_payment_terms.forEach((term) => {
          delete term.id
          delete term.sale_id
        })
      }

      if (sale.sale_bills) {
        sale.sale_bills.forEach((bill) => {
          delete bill.id
          delete bill.sale_id
        })
      }

      state.saleForm = JSON.parse(JSON.stringify(sale))
    },

    setPreSale(state, preSale) {
      let sale_products = []

      if (preSale.items) {
        sale_products = preSale.items.map((item) => {

          let productVariant = item.product?.product_variants?.[0] || null

          let productCompany = productVariant?.product_companies?.find(pc => pc.can_sell == 1) || null

          if (productVariant && productCompany) {
            productVariant = {
              ...productVariant,
              product: item.product,
              product_company: productCompany,
            }
          }

          let quantity = parseFloat(item.quantity)
          let price = productVariant.price_forward
          let price_cash = productVariant.price_cash
          let product_total = quantity * price

          return {
            product: item.product,
            product_variant: productVariant,
            product_variant_id: productVariant?.id,
            product_company_id: productCompany?.id,
            product_company: productCompany,
            quantity: quantity,
            price: price,
            price_cash: price_cash,
            price_forward: price,
            product_total: product_total,
            sub_total: product_total,
            product_discount: 0,
            product_discount_unity: 0,
            product_discount_percent: 0,
            discount: 0,
            discount_percent: 0,
            shipping: 0,
            expenses: 0,
            stock_status: 0,
            withdraw_quantity: 0,
          }
        })
      }

      state.saleForm = {
        id: null,
        ...state.saleForm,
        sale_products: sale_products,
      }
    },

    setOperation(state, operation) {
      state.saleForm.operation = operation
    },

    setCompany(state, company) {
      state.saleForm.company = company
    },

    setSalesman(state, salesman) {
      state.saleForm.salesman = salesman
    },

    setCustomer(state, customer) {
      state.saleForm.customer = customer
    },

    setDeliveryType(state, deliveryType) {
      state.saleForm.delivery_type = deliveryType
    },

    addProduct(state, sale_product) {
      state.saleForm.sale_products.push(sale_product);
    },

    updateProduct(state, { saleProduct, index }) {
      let newArr = JSON.parse(JSON.stringify(state.saleForm.sale_products));

      newArr[index] = saleProduct;

      state.saleForm.sale_products = newArr;
    },

    removeProduct(state, index) {
      state.saleForm.sale_products.splice(index, 1);
    },

    setGeneralDiscount(state, discount) {
      state.saleForm.general_discount = discount
    },

    setSalePaymentTerms(state, salePaymentTerms) {
      state.saleForm.sale_payment_terms = salePaymentTerms
    },

    setSaleBills(state, saleBills) {
      state.saleForm.sale_bills = saleBills
    },

    setStatus(state, status) {
      state.saleForm.status = status
    },

    setNotes(state, notes) {
      state.saleForm.notes = notes
    },

    setNegotiation(state, negotiation) {
      state.saleForm.negotiation_value = negotiation?.negotiation_value
      state.saleForm.negotiation_comments = negotiation?.negotiation_comments
      state.saleForm.has_negotiation = negotiation?.has_negotiation
    }

  },

  actions: {

    async storeSale({ commit, state }) {
      if (state.saleForm.id) {
        return this.dispatch("saleForm/update");
      } else {
        return this.dispatch("saleForm/store");
      }
    },

    async store({ commit, state }) {

      let saleObject = new SaleObject()

      saleObject.setSale(state.saleForm)

      return new Promise((resolve, reject) => {
        Vue.$http
          .store("sale/sale", saleObject.getSaleParams())
          .then((response) => resolve(response))
          .catch((error) => reject(error))
      })
    },

    async update({ commit, state }) {

      let saleObject = new SaleObject()

      saleObject.setSale(state.saleForm)

      return new Promise((resolve, reject) => {
        Vue.$http
          .update("sale/sale", state.saleForm.id, saleObject.getSaleParams())
          .then((response) => resolve(response))
          .catch((error) => reject(error))
      })
    },

    async loadSale({ commit, state }, id) {
      Vue.$http
        .show("sale/sale", id)
        .then(response => {
          commit('setSale', response.sale)
        })
        .catch(error => {

        })
    },

    async copySale({ commit, state }, id) {
      Vue.$http
        .show("sale/sale", id)
        .then(response => {
          commit('setSaleCopy', response.sale)
        })
        .catch(error => {

        })
    },

    async loadPreSale({ commit, state }, id) {
      Vue.$http
        .show("sale/pre-sale", id)
        .then(response => {
          commit('setPreSale', response.preSale)
        })
        .catch(error => {

        })
    }

  }
}